import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import modalContent from './modalContent';



const ModalPanel = ({ open, onClose }) => {
  const [content, setContent] = useState({ secondaryTitle: '', secondaryDescription: '' });

  useEffect(() => {
    setContent(modalContent);
  }, []);

  return (
    <Dialog
      sx={{
        zIndex: 3000,
        "& .MuiPaper-root": {
          borderRadius: "20pt",
        },
        "& .MuiDialogContent-root": {
          overflowY: "auto",
          scrollbarWidth: "none",
          "-ms-overflow-style": "none",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        },
        "@media (max-width: 600px)": {
          maxWidth: "100%",
          paddingRight: "5px",
          paddingLeft: "5px",
        },
      }}
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
    >
      <DialogContent
        className="smallscreen"
        sx={{
          paddingRight: { xs: "10pt", sm: "190pt" },
          paddingLeft: { xs: "10pt", sm: "60pt" },
          fontFamily: "Noto Sans",
          fontSize: "18px",
          lineHeight: "1.6",
          color: "#4F4F4F",
        }}
      >
        {/* Close button inside scrollable content */}
        <div style={{
          position: 'absolute',
          top: '20px',
          right: '20px',
          display: 'flex',
          justifyContent: 'flex-end',
        }}>

          <img
            onClick={onClose}
            style={{
              width: "30pt",
              height: "30pt"
            }}
            sx={{
              width: "30pt",
              height: "30pt",
              color: "#D9D9D9",
              cursor: 'pointer'

            }}
            src='/close.png'
          >
          </img>
        </div>

        {/* Title */}
        <Typography
          sx={{
            fontFamily: "Noto Sans",
            fontSize: "34px",
            fontWeight: 600,
            lineHeight: "46.31px",
            textAlign: "left",
            marginTop: "87px !important",
            color: '#000000'
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: content.secondaryTitle }} />
        </Typography>

        {/* Description */}
        <Typography
          component="div"
          sx={{
            whiteSpace: "pre-line",
            fontSize: "18px",
            lineHeight: "0.8",
            fontFamily: "Noto Sans",
            marginBottom: "140px !important"
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: content.secondaryDescription }} />
        </Typography>

      </DialogContent>
    </Dialog>
  );
};

export default ModalPanel;
